/* =====================================================================
   SPAGNOLO · Tallas en la tarjeta con compra rápida — 23-oct-2026
   Pulsar una talla de la franja (snippets/sp-card-tallas.liquid) la añade
   al carrito y avisa al tema con el evento «cart:update», el mismo que usa
   Horizon: se actualizan el contador y el carrito lateral, que se abre solo
   (ajuste «abrir carrito al añadir» del tema).
   La medición (dataLayer) recoge el «add_to_cart» porque escucha /cart/add.
   Pulsar el fondo de la franja no lleva a la ficha (evita clics fallidos).
   Para volver atrás: quitar la línea de este fichero en layout/theme.liquid.
   ===================================================================== */
(function () {
  if (window.spTallasListo) return;
  window.spTallasListo = true;

  var AVISO_MS = 3000;

  function rutaAdd() {
    return (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';
  }

  function rutaCarrito() {
    var r = (window.Theme && Theme.routes && Theme.routes.cart_url) || '/cart';
    return r.replace(/\/$/, '') + '.js';
  }

  function aviso(caja, texto) {
    var a = caja.querySelector('.sp-tallas__aviso');
    if (!a) return;
    clearTimeout(caja._spAviso);
    a.textContent = texto || '';
    caja._spAviso = setTimeout(function () {
      a.textContent = '';
      caja.classList.remove('is-error', 'is-hecho');
    }, AVISO_MS);
  }

  function seccionesCarrito() {
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (c) {
      var id = c.getAttribute('data-section-id');
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  function anadir(boton, caja) {
    var id = Number(boton.getAttribute('data-variant-id'));
    if (!id) return;

    var cuerpo = { items: [{ id: id, quantity: 1 }] };
    var secciones = seccionesCarrito();
    if (secciones.length) {
      cuerpo.sections = secciones.join(',');
      cuerpo.sections_url = window.location.pathname;
    }

    caja.classList.remove('is-error', 'is-hecho');
    caja.classList.add('is-cargando');
    boton.classList.add('is-pulsada');

    fetch(rutaAdd(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(cuerpo)
    })
      .then(function (r) {
        return r.json().then(function (d) {
          return { ok: r.ok, d: d || {} };
        });
      })
      .then(function (res) {
        if (!res.ok || res.d.status) {
          throw new Error(res.d.description || res.d.message || 'No se ha podido añadir');
        }
        var secc = res.d.sections;
        // El carrito completo: el contador queda exacto y las tarjetas no piden /cart.js cada una
        return fetch(rutaCarrito(), { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .catch(function () { return null; })
          .then(function (carrito) {
            var datos = carrito && carrito.items
              ? { source: 'sp-tallas', itemCount: carrito.item_count }
              : { source: 'product-form-component', itemCount: 1 };
            datos.productId = caja.getAttribute('data-product-id');
            datos.variantId = String(id);
            datos.sections = secc;
            boton.dispatchEvent(
              new CustomEvent('cart:update', {
                bubbles: true,
                detail: { resource: carrito || {}, sourceId: 'sp-tallas-' + id, data: datos }
              })
            );
            caja.classList.add('is-hecho');
            aviso(caja, 'Añadida al carrito');
          });
      })
      .catch(function (err) {
        caja.classList.add('is-error');
        aviso(caja, (err && err.message) || 'No se ha podido añadir');
      })
      .then(function () {
        caja.classList.remove('is-cargando');
        boton.classList.remove('is-pulsada');
      });
  }

  // Fase de captura: la franja se queda el clic antes que la tarjeta (que llevaría a la ficha)
  document.addEventListener(
    'click',
    function (e) {
      var caja = e.target && e.target.closest ? e.target.closest('.sp-tallas') : null;
      if (!caja) return;
      e.preventDefault();
      e.stopPropagation();

      var boton = e.target.closest('.sp-tallas__btn');
      if (!boton || boton.getAttribute('aria-disabled') === 'true') return;
      if (caja.classList.contains('is-cargando')) return;
      anadir(boton, caja);
    },
    true
  );
})();
